import { Modal } from '@mantine/core';
import { useMounted } from '@mantine/hooks';
import { useUnit } from 'effector-react';
import { onboardingModalModel } from '../model';
import cls from './onboarding-modal.module.scss';

type OnboardingModalProps = {
	targetId: string;
};

export const OnboardingModal = ({ targetId }: OnboardingModalProps) => {
	const [opened, close] = useUnit([
		onboardingModalModel.onboardingSwitcher.$active,
		onboardingModalModel.onboardingSwitcher.disable,
	]);

	const mounted = useMounted();

	return (
		mounted && (
			<Modal.Root
				opened={opened}
				portalProps={{
					target: document.getElementById(targetId)!,
				}}
				classNames={{ overlay: cls.onboardingModalGamePageOverlay }}
				closeOnClickOutside={false}
				closeOnEscape={false}
				onClose={close}
			>
				<Modal.Overlay id='onboarding-game-page-overlay' />
			</Modal.Root>
		)
	);
};
